import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

class ApiClient {
  private axios: AxiosInstance
  
  constructor() {
    this.axios = axios.create({
      baseURL: import.meta.env.VITE_API_URL || 'https://myapp.chatelainxpert.be',
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    
    this.setupInterceptors()
  }
  
  private setupInterceptors() {
    this.axios.interceptors.request.use(
      (config) => {
        const token = this.getAuthToken()
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )
    
    this.axios.interceptors.response.use(
      (response) => response.data,
      async (error) => {
        if (error.response?.status === 401) {
          this.clearAuthToken()
          window.location.href = '/signin'
        }
        return Promise.reject(error)
      }
    )
  }
  
  private getAuthToken(): string | null {
    return localStorage.getItem('authToken')
  }
  
  setAuthToken(token: string | null) {
    if (token) {
      localStorage.setItem('authToken', token)
    } else {
      localStorage.removeItem('authToken')
    }
  }
  
  clearAuthToken() {
    localStorage.removeItem('authToken')
  }
  
  get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.axios.get(url, config)
  }
  
  post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.axios.post(url, data, config)
  }
  
  put<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.axios.put(url, data, config)
  }
  
  patch<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.axios.patch(url, data, config)
  }
  
  delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.axios.delete(url, config)
  }
}

export const apiClient = new ApiClient()
export const setAuthToken = (token: string | null) => apiClient.setAuthToken(token)
export const clearAuthToken = () => apiClient.clearAuthToken()